import { createEndpoint } from '@/shared/models/api';
import { IdValue } from '@/app/api/morgan-thermal';

export type MaterialCategory = IdValue;

export const getMaterialCategories = createEndpoint<MaterialCategory[]>(({ fetch }) => (countryId) => fetch(`/Configuration/GetMaterialCategories`));